/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ConversationsInputs */



/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Nav_ConversationsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_conversations = /** @type {((inputs?: Nav_ConversationsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ConversationsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversations")
	return /** @type {LocalizedString} */ ("Conversations")
});